export default __webpack_public_path__ + "media/titles/title_6_locale_it-b1401260.png";